export default {
  'component.globalHeader.search': 'Tìm kiếm',
  'component.globalHeader.help': 'Trợ giúp',
  'component.globalHeader.notification': 'Thông báo',
  'component.globalHeader.notification.empty': 'Bạn đã xem hết tất cả thông báo.',
  'component.globalHeader.message': 'Tin nhắn',
  'component.globalHeader.message.empty': 'Bạn đã xem hết tất cả tin nhắn.',
  'component.globalHeader.event': 'Sự kiện',
  'component.globalHeader.event.empty': 'Bạn đã xem hết tất cả sự kiện.',
  'component.noticeIcon.clear': 'Xóa',
  'component.noticeIcon.cleared': 'Đã xóa',
  'component.noticeIcon.empty': 'Không có thông báo',
  'component.noticeIcon.view-more': 'Xem thêm',
  'component.globalHeader.account.manage': 'Quản lý tài khoản',
  'component.globalHeader.logout': 'Đăng xuất',
};
